import { PageHero, Container } from "@/components/Sections";
import { Reveal } from "@/components/Reveal";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import { CONTACT, waLink, IMAGES } from "@/data/site";
import { WhatsAppIcon } from "@/components/Header";
import { useQuote } from "@/components/QuoteDialog";

export default function Contatti() {
  const { openQuote } = useQuote();
  const cards = [
    { icon: Phone, label: "Cellulare", value: CONTACT.phoneDisplay, href: `tel:${CONTACT.phoneRaw}` },
    { icon: Phone, label: "Telefono fisso", value: CONTACT.landlineDisplay, href: `tel:${CONTACT.landlineRaw}` },
    { icon: WhatsAppIcon, label: "WhatsApp", value: "Scrivici ora", href: waLink() },
    { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: MapPin, label: "Sede", value: "Roma, Italia", href: null },
  ];
  return (
    <>
      <PageHero overline="Contatti" title="Parliamo del tuo trasporto." img={IMAGES.warehouse}
        subtitle="Rispondiamo di norma entro poche ore. Contattaci come preferisci o richiedi subito un preventivo gratuito." />
      <section className="py-24 md:py-32" data-testid="contatti">
        <Container>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-5">
            {cards.map((c, i) => {
              const Icon = c.icon;
              const inner = (
                <div className="bg-white border border-zinc-100 rounded-2xl p-7 h-full hover:shadow-[0_20px_40px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all duration-200">
                  <div className="w-12 h-12 rounded-xl bg-[#FF5A00]/10 flex items-center justify-center text-[#FF5A00]"><Icon size={22} /></div>
                  <div className="text-[11px] uppercase tracking-wider font-bold text-zinc-400 mt-5">{c.label}</div>
                  <div className="font-head text-lg font-bold mt-1">{c.value}</div>
                </div>
              );
              return (
                <Reveal key={i} delay={i * 0.08}>
                  {c.href ? <a href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid={`contact-${c.label.replace(/\s+/g, "-").toLowerCase()}`}>{inner}</a> : inner}
                </Reveal>
              );
            })}
          </div>
          <Reveal delay={0.1}>
            <div className="mt-8 bg-[#121212] rounded-[1.75rem] p-10 md:p-14 text-center relative overflow-hidden">
              <div className="absolute inset-0 noise-overlay opacity-[0.05]" />
              <div className="relative">
                <h2 className="font-head text-3xl md:text-4xl font-extrabold text-white tracking-tight">Richiedi un preventivo gratuito</h2>
                <p className="text-zinc-400 mt-3 max-w-lg mx-auto">Indicaci partenza, destinazione e cosa devi trasportare. Ti ricontattiamo con la soluzione più adatta.</p>
                <button onClick={() => openQuote()} data-testid="contatti-quote-button"
                  className="mt-7 h-14 px-8 rounded-full bg-[#FF5A00] text-white font-bold inline-flex items-center gap-2 hover:bg-[#E04F00] transition-colors">
                  Richiedi preventivo <ArrowRight size={18} />
                </button>
              </div>
            </div>
          </Reveal>
        </Container>
      </section>
    </>
  );
}
